import WorkInProgressState from "Components/organisms/work-in-progress"
import { Container, Breadcrumb } from "reactstrap"

const ExecutiveDashboardTemplate = () => {
    return <div className="page-content">
        <Container fluid className="section-container">
            <Breadcrumb
                title="Executive"
                breadcrumbItem="Dashboard"
            />
            <WorkInProgressState
                title={"Work in progress"}
                subtitle={"This page is still under construction. Come back another time!"}
            />

        </Container>
    </div>
}

export default ExecutiveDashboardTemplate